import React from 'react';

import { Icon, Radio } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

import { AliasLabel, aliasIcons, aliasIconsSize, getAliasLabel } from '../types';

import {
  AddressContainer,
  AddressInfoLine,
  AliasInfoLine,
  AliasTextInfoLine,
  DeliveryAddressesButton,
  DeliveryAddressesButtonText,
  DeliveryAddressesEditButtonContainer,
  DeliveryAddressesEditContainer,
  DeliveryAddressesInfoContainer,
  InfoContainer,
  InfoLine,
} from './styled';
import { IDeliveryAddressItemProps } from './types';

export const DeliveryAddressItem: React.FC<React.PropsWithChildren<IDeliveryAddressItemProps>> = ({
  value,
  address,
  onEdit,
  onRemove,
}) => {
  const aliasLabels = getAliasLabel();
  const baseAlias =
    (Object.keys(aliasIcons).find(base =>
      address.alias?.toLowerCase().startsWith(base.toLowerCase())
    ) as keyof typeof aliasIcons) || AliasLabel.Other;

  const iconVariant = aliasIcons[baseAlias];
  const iconSize = aliasIconsSize[baseAlias];
  const displayAlias = aliasLabels[baseAlias];

  const handleEditItem = () => {
    if (onEdit) {
      onEdit();
    }
  };

  const onRemoveItemPress = () => {
    onRemove?.();
  };

  return (
    <AddressContainer testID="delivery-address-item" borderTopWidth={value === '0' ? '1px' : '0'}>
      <DeliveryAddressesInfoContainer>
        <Radio
          value={value}
          alignItems="center"
          justifyContent="space-between"
          flexDirection="row-reverse"
          width={'full'}
        >
          <InfoContainer>
            <AddressInfoLine>{address.addressLine1}</AddressInfoLine>
            <InfoLine>
              {address.addressLine2 && (
                <>{t('unitNumber', { unitNumber: address.addressLine2 })}, </>
              )}
              {address.city}, {address.state} {address.zip}, {address.phoneNumber}
            </InfoLine>
            {address.alias && (
              <InfoLine marginTop={2}>
                <AliasInfoLine>
                  <Icon variant={iconVariant} size={iconSize} color={primitive.bk.$white} />
                  <AliasTextInfoLine>{displayAlias}</AliasTextInfoLine>
                </AliasInfoLine>
              </InfoLine>
            )}
          </InfoContainer>
        </Radio>
      </DeliveryAddressesInfoContainer>
      <DeliveryAddressesEditContainer>
        <DeliveryAddressesEditButtonContainer marginRight="$4">
          <DeliveryAddressesButton
            keepIconSize
            accessibilityLabel={`${t('remove')} ${address.addressLine1} `}
            testID="remove-button"
            onPress={onRemoveItemPress}
            leftIcon={<Icon variant="bkRemove" size="md" />}
            marginRight="$4"
          />
          <DeliveryAddressesButton
            accessibilityLabel={`${t('edit')} ${address.addressLine1} `}
            testID="edit-button"
            onPress={handleEditItem}
          >
            <DeliveryAddressesButtonText>{t('edit')}</DeliveryAddressesButtonText>
          </DeliveryAddressesButton>
        </DeliveryAddressesEditButtonContainer>
      </DeliveryAddressesEditContainer>
    </AddressContainer>
  );
};
